export interface PricingOption {
  format: 'online' | 'offline';
  type: 'individual' | 'closed_group' | 'group';
  price: number; // Оплата в месяц
}

export interface CourseData {
  id: string;
  title: string;
  duration: string;
  frequency: string;
  description: string;
  level?: string;
  icon: string;
  color: string;
  pricing: PricingOption[];
  specialOffer?: {
    monthlyPayment: number;
    totalMonthly: number;
    totalUpfront: number;
    discount: number;
  };
  isBootcamp?: boolean;
  prerequisites?: string;
  timeSlots?: string[];
  weekends?: string;
  trainingType?: string; // Тип обучения: СТАНДАРТ или УСКОРЕННОЕ ОБУЧЕНИЕ
}

export const COURSES_DATA: CourseData[] = [
  // Python курсы
  {
    id: 'python-standard',
    title: 'Python Программирование',
    duration: '12 месяцев',
    frequency: '2 занятия в неделю',
    description: 'Углублённое изучение Python с нуля до создания реальных проектов. Первый курс разделён на 2 этапа по 6 месяцев',
    trainingType: 'СТАНДАРТ',
    icon: 'python',
    color: '#F5E6FE',
    pricing: [
      { format: 'online', type: 'individual', price: 22800 },
      { format: 'offline', type: 'individual', price: 28600 },
      { format: 'online', type: 'closed_group', price: 14600 },
      { format: 'offline', type: 'closed_group', price: 16800 },
      { format: 'online', type: 'group', price: 11000 },
      { format: 'offline', type: 'group', price: 12600 },
    ]
  },
  {
    id: 'python-intensive',
    title: 'Python Программирование',
    duration: '6 месяцев',
    frequency: '5 занятий в неделю',
    description: 'Максимально интенсивный курс для быстрого старта в программировании на Python. Курс разделён на 2 этапа по 3 месяца',
    trainingType: 'УСКОРЕННОЕ ОБУЧЕНИЕ',
    icon: 'python',
    color: '#F5E6FE',
    pricing: [
      { format: 'online', type: 'individual', price: 38600 },
      { format: 'offline', type: 'individual', price: 48200 },
      { format: 'online', type: 'closed_group', price: 22600 },
      { format: 'offline', type: 'closed_group', price: 28600 },
      { format: 'online', type: 'group', price: 16800 },
      { format: 'offline', type: 'group', price: 22800 },
    ]
  },

  // JavaScript курсы
  {
    id: 'javascript-standard',
    title: 'JavaScript Программирование',
    duration: '12 месяцев',
    frequency: '2 занятия в неделю',
    description: 'Изучение JavaScript с нуля до создания современных веб-приложений. Первый курс разделён на 2 этапа по 6 месяцев',
    trainingType: 'СТАНДАРТ',
    icon: 'javascript',
    color: '#FFF9DD',
    pricing: [
      { format: 'online', type: 'individual', price: 22800 },
      { format: 'offline', type: 'individual', price: 28600 },
      { format: 'online', type: 'closed_group', price: 14600 },
      { format: 'offline', type: 'closed_group', price: 16800 },
      { format: 'online', type: 'group', price: 11000 },
      { format: 'offline', type: 'group', price: 12600 },
    ]
  },
  {
    id: 'javascript-intensive',
    title: 'JavaScript Программирование',
    duration: '6 месяцев',
    frequency: '5 занятий в неделю',
    description: 'Интенсивное изучение JavaScript для быстрого старта в веб-разработке. Курс разделён на 2 этапа по 3 месяца',
    trainingType: 'УСКОРЕННОЕ ОБУЧЕНИЕ',
    icon: 'javascript',
    color: '#FFF9DD',
    pricing: [
      { format: 'online', type: 'individual', price: 38600 },
      { format: 'offline', type: 'individual', price: 48200 },
      { format: 'online', type: 'closed_group', price: 22600 },
      { format: 'offline', type: 'closed_group', price: 28600 },
      { format: 'online', type: 'group', price: 16800 },
      { format: 'offline', type: 'group', price: 22800 },
    ]
  },

  // Другие курсы
  {
    id: 'computer-literacy',
    title: 'Компьютерная грамотность',
    duration: '1 месяц',
    frequency: '2 раза в неделю',
    description: 'Основы работы с компьютером для начинающих пользователей',
    icon: 'p4',
    color: '#E8F4FD',
    pricing: [
        // { format: 'online', type: 'individual', price: 16800 },
        // { format: 'offline', type: 'individual', price: 22600 },
        // { format: 'online', type: 'closed_group', price: 14600 },
        // { format: 'offline', type: 'closed_group', price: 16800 },
        // { format: 'online', type: 'group', price: 11000 },
        // { format: 'offline', type: 'group', price: 12600 },
        { format: 'online', type: 'individual', price: 16800 },
        { format: 'offline', type: 'individual', price: 16800 },
        { format: 'online', type: 'closed_group', price: 14600 },
        { format: 'offline', type: 'closed_group', price: 14600 },
        { format: 'online', type: 'group', price: 11000 },
        { format: 'offline', type: 'group', price: 11000 },
    ]
  },
  {
    id: 'bootcamp',
    title: 'Буткемп (Сатисар)',
    duration: '5 месяцев',
    frequency: '5 занятий в неделю',
    description: 'Интенсивная программа полного погружения в программирование на Python',
    level: 'с базой (знание основ Python)',
    icon: 'p3',
    color: '#fdcbd6',
    timeSlots: ['09:00-15:00', '15:00-21:00'],
    weekends: 'суббота, воскресенье',
    isBootcamp: true,
    prerequisites: 'знание основ Python',
    pricing: [
      { format: 'online', type: 'group', price: 140000 },
      { format: 'offline', type: 'group', price: 160000 },
    ]
  },

];

export const FORMAT_LABELS = {
  online: 'Онлайн',
  offline: 'Оффлайн'
};

export const TYPE_LABELS = {
  individual: 'Индивидуально',
  closed_group: 'Закрытая группа',
  group: 'Группа'
};
